<template>
    <aside
        class="ProductSidebar"
    >
        <header
            class="desk-flex-end-b pb-base"
        >
            <h6 class="h7 lap-mb-small">
                More details
            </h6>
        </header>

        <div
            v-if="mapsUrl != null"
            class="ProductSidebar__map"
        >
            <iframe
                width="100%"
                height="200"
                frameborder="0"
                style="border:0"
                :src="mapsUrl"
            >
            </iframe>

        </div>
        <ul
            class="ProductSidebar__item"
        >
            <li
                v-if="address"
            >
                <BaseIcon
                    icon="address"
                />
                <div class="ProductSidebar__address">
                    <span v-for="(part, index) in formattedAddress" :key="part" class="address-part">
                        <span v-html="part" />{{ index < formattedAddress.length - 1 ? `,&nbsp;` : `` }}
                    </span>
                </div>
            </li>
            <li
                v-if="(dates && dates.length) || (pastDates && pastDates.length)"
                :class="{'is-dates': dates.length > 1 || pastDates}"
            >
                <BaseIcon icon="dates" />
                <span>
                    <span v-for="(group, index) in dates" :key="index">
                        {{ dateformatter(group) }}
                    </span>

                    <button
                        v-if="pastDates && pastDates.length"
                        @click="pastDatesVisible = !pastDatesVisible"
                        :class="{'mt-small ': dates && dates.length}"
                        class="text--blue">
                        <span v-if="!pastDatesVisible">See</span><span v-else>Hide</span> past dates
                    </button>

                    <div v-if="pastDatesVisible" class="mt-small">
                        <span v-for="(group, index) in pastDates" :key="index">
                            {{ dateformatter(group) }}
                        </span>
                    </div>
                </span>
            </li>
            <!--  <li
                v-if="ticket"
            >
                <BaseIcon
                    icon="ticket"
                />
                <span>From {{ ticket }}</span>
            </li> -->
            <li
                v-if="phone"
            >
                <BaseIcon
                    icon="phone"
                />
                <a :href="phoneUrl">{{ formattedPhone }}</a>
            </li>
            <li
                v-if="email"
            >
                <BaseIcon
                    icon="email"
                />
                <a
                    :href="emailUrl"
                    class="link"
                >
                    Send email
                </a>
            </li>
            <li
                v-if="website"
            >
                <BaseIcon
                    icon="website"
                />
                <a
                    :href="website"
                    target="_blank"
                    class="link"
                >
                    Visit the website
                </a>
            </li>
        </ul>
        <SocialLinks v-if="socials" :items="socials" classes="mt-small" />
        <BaseButton
            v-if="booking"
            tag="a"
            :href="booking"
            target="_blank"
            class="mt-medium"
        >
            Book
        </BaseButton>
    </aside>
</template>
<script>
import moment from 'moment';
import gmapsInit from '@utils/gmap.js';

export default {
    name: 'ProductSidebar',
    props: {
        center: {
            type: String,
            default: null
        },
        address: {
            type: Array,
            default: null
        },
        phone: {
            type: String,
            default: null
        },
        website: {
            type: String,
            default: null
        },
        booking: {
            type: String,
            default: null
        },
        email: {
            type: String,
            default: null
        },
        dates: {
            type: Array,
            default: null
        },
        socials: {
            type: Array,
            default: null
        },
        pastDates: {
            type: Array,
            default: null
        },
        ticket: {
            type: String,
            default: null
        },
        mapsUrl: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            pastDatesVisible: false,
        };
    },
    computed: {
        lat() {
            return Number(this.center.split(',')[0])
        },
        lng() {
            return Number(this.center.split(',')[1])
        },
        phoneUrl() {
            return this.phone ? `tel:${this.phone}` : null
        },
        formattedPhone() {
            if (this.phone) {
                const phone = this.phone.replace(/[- )(]/g,'');

                const prefix = phone.substring(0, 2);
                const digits = phone.substring(2);

                if(['02', '03', '04', '07', '08'].indexOf(prefix) >= 0) {

                    if (prefix == '04') {
                        return `${prefix}${digits.substring(0, 2)} ${digits.substring(2,5)} ${digits.substring(5)}`;
                    } else {
                        return `(${prefix}) ${digits.substring(0, 4)} ${digits.substring(4)}`;
                    }

                } else if (phone.substring(0, 1) != 0) {

                    return `${phone.substring(0, 4)} ${phone.substring(4)}`;

                } else {

                    return this.phone;
                }
            }

            return null;
        },
        emailUrl() {
            return this.email ? `mailto:${this.email}` : null
        },
        formattedAddress() {
            return this.address.filter(part => part !== null);
        }
    },
    async mounted() {
        try {
            if (this.center) {
                const google = await gmapsInit();

                const map = new google.maps.Map(document.getElementById('googleMapsElement'), {
                    center: {lat: this.lat, lng: this.lng},
                    zoom: 8,
                    disableDefaultUI: true
                })

                const marker = new google.maps.Marker({position: {lat: this.lat, lng: this.lng}, map: map});
            }

        } catch (error) {
            console.error(error);
        }
    },

    methods: {
        dateformatter(range) {
            const first = range[0];
            const last = range[range.length - 1];

            if (first === last) {
                return moment(first).format('D MMM YYYY');
            }

            return `${moment(first).format('D MMM')} - ${moment(last).format('D MMM YYYY')}`;
        }
    }
}
</script>
<style lang="scss" scoped>

    header {
        a {
            font-size: 14px;
            color: $action-color;
            font-weight: 600;

            @include media-query(lap-and-up) {
                font-size: 16px;
            }
        }
    }

    .ProductSidebar__item {

        li {
            display: flex;
            align-items: center;
            font-size: 14px;
            padding: 0.65rem 0;
            border-bottom: 1px solid getColor('sand');

            @include media-query(lap-and-up) {
                font-size: 16px;
            }

            &.is-dates {
                align-items: flex-start;
            }

            .BaseIcon {
                margin-right: 0.75rem;
                color: getColor('sand');
                font-size: 20px;
            }

            > span {
                width: 80%;

                > span, > div > span {
                    margin-bottom: 12px;
                    display: block;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }

    .ProductSidebar__map {
        border-top: 2px solid $action-color;
    }

    .ProductSidebar__address {
        display: flex;
        flex-wrap: wrap;
    }
</style>
